export function formatNumber(value: string, digits?: number): string {
    const rawValue = value.replace(/\s/g, '').replace(/^0+(?=\d)/, '')
    const separator = rawValue.includes(',') ? ',' : '.'
    const [integer, decimal = ''] = rawValue.split(/[,.]/)

    if (digits) {
        return (
            integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
            (decimal ? `${separator}${decimal.slice(0, digits)}` : '')
        )
    }
    return (
        integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
        (decimal ? `${separator}${decimal.slice(0, 3)}` : '')
    )
}

export function parseNumber(value: string): number {
    return parseFloat(value.replaceAll(' ', '').replace(',', '.'))
}

export function handleKeyDownNumeric(e: React.KeyboardEvent<HTMLInputElement>) {
    const allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Home',
        'End',
        'Shift',
        'Control',
        'Alt',
        'Meta',
    ]
    if (allowedKeys.includes(e.key)) {
        return
    }
    if (e.ctrlKey || e.metaKey) {
        const allowedShortcuts = ['a', 'c', 'v', 'x', 'z', 'y']
        if (allowedShortcuts.includes(e.key.toLowerCase())) {
            return
        }
    }

    if (!/[\d\s]/.test(e.key)) {
        e.preventDefault()
    }
}
